import { CustomShippingCarrierKindEnum } from './CustomShippingCarrierKindEnum'

// Fixed carrier label for the "Will Pickup" custom option — the customer/vendor collects it
// themselves, so there is no real carrier; only a free-text service code is collected. Persisted
// verbatim as the stored carrier string by both the sales and logistics shipping panels.
export const WILL_PICKUP_CARRIER = 'Will Pickup'

// A custom carrier option carries a `kind` and no `shippingAmount`. The two options are appended
// to the bottom of the live ShipEngine rates so the user can record a custom carrier (Other
// Carrier / Will Pickup) without calling ShipEngine.
export type CustomCarrierOption = {
  label: string
  value: string
  kind: CustomShippingCarrierKindEnum
}

export const customCarrierOptions: CustomCarrierOption[] = [
  { label: 'Other Carrier', value: 'custom:other', kind: CustomShippingCarrierKindEnum.Other },
  { label: WILL_PICKUP_CARRIER, value: 'custom:will-pickup', kind: CustomShippingCarrierKindEnum.WillPickup },
]
